/** Inbox integration ng Service Desk (CH-015, SD-S1-49): Gawing ticket, ang ticket chip at Mga naka-link na ticket. */
export const serviceInbox = {
  convert: {
    button: "Gawing ticket",
    title: "Gawing ticket",
    description: "Napunan na mula sa buod ng handoff. Makukuha ni {{name}} ang numero ng ticket sa chat at sa e-mail kung nakatsek ang kahon.",
    descriptionNoNotify: "Napunan na mula sa buod ng handoff. Hindi sasabihan si {{name}} hangga't hindi ka sumasagot.",
    descriptionLabel: "Paglalarawan (buod ng AI)",
    descriptionHint: "Puwede mo itong i-edit. Ang pamagat ang nakikita ng kliyente, hindi ang buod ng AI.",
    summaryNone: "Walang buod na naisulat para sa chat na ito, kaya walang laman ang paglalarawan sa simula.",
    requester: "Humihiling",
    requesterFromChat: "Kinuha sa chat: {{name}}. Maghanap para pumili ng kasalukuyang contact.",
    notify: "Sabihan ang kliyente",
    notifyHint: "Magpapadala ng resibo na may numero ng ticket. I-off para tahimik lang.",
    keepOpen: "Panatilihing bukas ang handoff",
    keepOpenHint: "Mananatili ang chat sa team para makapagpatuloy ka sa pagsagot. I-off para i-resolve na ang chat.",
    submit: "Gumawa ng ticket",
    cancel: "Kanselahin",
    created: "Nagawa ang ticket {{number}} mula sa chat na ito.",
    createdResolved: "Nagawa ang ticket {{number}} at na-resolve ang chat.",
    resolveFailed: "Nagawa ang ticket {{number}}, pero hindi ma-resolve ang chat. I-resolve ito sa status menu.",
    typesError: "Hindi namin ma-load ang mga uri ng ticket.",
    noTypes: "Wala pang uri ng ticket na puwedeng gawin mula sa inbox. Magdagdag sa Settings ng Serbisyo.",
    unavailable: "Hindi available ang mga ticket sa workspace na ito.",
  },
  chip: { open: "Buksan ang ticket {{number}}", label: "Ticket {{number}}" },
  linked: {
    title: "Mga naka-link na ticket",
    none: "Wala pang ticket. Gawing ticket ang chat na ito kapag kailangan ng follow-up.",
    open: "Buksan ang ticket {{number}}",
    error: "Hindi namin ma-load ang mga naka-link na ticket.",
    retry: "Subukan ulit",
  },
} as const;
